export class ProfileBookmark {
    id: string;
    profileId: string;
    accountId: string;
    notes: string;

    static parse(json: any): ProfileBookmark {
        let profileBookmark = new ProfileBookmark();
        Object.assign(profileBookmark, json);
        return profileBookmark;
    }
}
